export const EnabledFlags = {
	Predictive: 'predictiveEnabled',
};
